import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { useState, useEffect } from 'react';
import { Ads } from './news-ads.esm.js';

//   import { useResponsiveAdsLogic } from './hooks/useResponsiveAdsLogic';

var useResponsiveAdsLogic = function useResponsiveAdsLogic(responsiveAdSizeMappings, defaultNumberOfAds) {
  var initalAdSizes = [[]];
  var _useState = useState(initalAdSizes),
    _useState2 = _slicedToArray(_useState, 2),
    adSizes = _useState2[0],
    setAdSizes = _useState2[1];
  var _useState3 = useState(defaultNumberOfAds),
    _useState4 = _slicedToArray(_useState3, 2),
    numberOfAds = _useState4[0],
    setNumberOfAds = _useState4[1];
  useEffect(function () {
    var mediaQueries = [];
    var listenerFunctions = [];
    responsiveAdSizeMappings.forEach(function (mapping) {
      mediaQueries.push(window.matchMedia("".concat(mapping.minWidth ? "(min-width: ".concat(mapping.minWidth, "px)") : '').concat(mapping.minWidth && mapping.maxWidth ? ' and ' : '').concat(mapping.maxWidth ? "(max-width: ".concat(mapping.maxWidth, "px)") : '')));
      listenerFunctions.push(function (event) {
        if (event.matches) {
          setAdSizes(mapping.adSizes);
          if (mapping.numberOfAds) {
            setNumberOfAds(mapping.numberOfAds);
          } else {
            setNumberOfAds(defaultNumberOfAds);
          }
        }
      });
    });
    mediaQueries.forEach(function (mediaQuery, index) {
      mediaQuery.addListener(listenerFunctions[index]);
    });
    mediaQueries.forEach(function (mediaQuery, index) {
      listenerFunctions[index](mediaQuery);
    });
    return function () {
      mediaQueries.forEach(function (mediaQuery, index) {
        mediaQuery.removeListener(listenerFunctions[index]);
      });
    };
  }, [defaultNumberOfAds, responsiveAdSizeMappings]);
  return {
    adSizes: adSizes,
    numberOfAds: numberOfAds
  };
};
var ResponsiveAds = function ResponsiveAds(props) {
  var adConfigs = props.adConfigs,
    onProcessedAllAdsHandler = props.onProcessedAllAdsHandler,
    uniqueId = props.uniqueId,
    isRightPropertyAds = props.isRightPropertyAds,
    adSpacing = props.adSpacing;
  var _useResponsiveAdsLogi = useResponsiveAdsLogic(adConfigs.responsiveAdSizeMappings, adConfigs.numberOfAds),
    adSizes = _useResponsiveAdsLogi.adSizes,
    numberOfAds = _useResponsiveAdsLogi.numberOfAds;
  var numberShownAds = numberOfAds;
  if (isRightPropertyAds && numberOfAds > 4) {
    numberShownAds = 4;
  }
  return adSizes[0].length ? /*#__PURE__*/React__default.createElement(Ads, {
    uniqueId: uniqueId,
    adStretchOptions: adConfigs.adStretchOptions,
    adConfig: adConfigs.adConfig,
    adSizes: adSizes,
    numberOfAds: numberShownAds,
    onRenderHandler: adConfigs.onRenderHandler,
    onProcessedAllAdsHandler: onProcessedAllAdsHandler,
    adSpacing: adSpacing
  }) : null;
};

export { ResponsiveAds, useResponsiveAdsLogic };
//# sourceMappingURL=responsive-ads.esm.js.map
